// extracted by mini-css-extract-plugin
export var container = "IndividualSetStatistics-module--container--b7b77";
export var statistics = "IndividualSetStatistics-module--statistics--4233f";